import {
  Container,
  Grid,
  MenuItem,
  ThemeProvider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { ITheme, theme } from "../constants/theme";
import { useHistory } from "react-router-dom";
import BackButton from "../components-atoms/BackButton";
import { Stamp } from "../components-atoms/Stamp";
import ThreeDotMenu from "./ThreeDotMenu";
import EditIcon from '@material-ui/icons/Edit';
import BlockIcon from '@material-ui/icons/Block';

interface ProOrganisationDetailHeaderProps {
  name?: string;
  status?: string;
  ProTeamId?: string;
  isAdmin?: boolean;
  onEdit?: () => void;
  onArchive?: () => void;
}

export const ProOrganisationDetailHeader = ({ 
  name, 
  status, 
  ProTeamId, 
  isAdmin, 
  onEdit, 
  onArchive 
}: ProOrganisationDetailHeaderProps) => {
  const history = useHistory<{ from: string; }>();
  const classes = useStyles();

  const handleEdit = () => {
    if (onEdit) {
      onEdit();
    }
  };

  const handleArchive = () => {
    if (onArchive) {
      onArchive();
    }
  };

  return (
    <Container className={classes.header}>
      <ThemeProvider theme={theme}>
        <Grid container direction="row">
          {isAdmin &&
            <Grid xs={1} item container>
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                xs={12}>
                <BackButton
                  onClick={() => history.goBack()}
                />
              </Grid>
            </Grid>
          }
          <Grid item xs={6} className={classes.headerOrderDetailSection}>
            <Grid item>
              <Typography
                variant="body1"
                component="p"
                color="textSecondary"
                className={classes.headerSubtitle}>
                Pro Organisation
              </Typography>
            </Grid>
            <Grid item container>
              <Grid item>
                <Typography variant="h5" component="h1" color="textPrimary">
                  {name}
                </Typography>
              </Grid>
              {status && <Stamp type={status.includes("Enabled") ? "success" : "fail"} text={status} />}
            </Grid>
          </Grid>
          <Grid
            item
            alignItems="center"
            justifyContent="flex-end"
            container
            className={classes.headerButtonContainer}
            xs={5}>
            {!isAdmin ? <></> :
              <ThreeDotMenu>
                  <MenuItem
                    onClick={handleEdit}
                  >
                    <EditIcon />
                    <Typography variant="body2" component="p" style={{ paddingLeft: '16px' }}>
                      Edit Information
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    style={{ color: theme.palette.error.main }}
                    onClick={handleArchive}
                  >
                    <BlockIcon />
                    <Typography variant="body2" component="p" style={{ paddingLeft: '16px' }}>
                      Archive TK Pro Team
                    </Typography>
                  </MenuItem>
                </ThreeDotMenu>
            }
          </Grid>
        </Grid>
      </ThemeProvider>
    </Container>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  header: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  headerOrderDetailSection: {
    paddingLeft: 16,
  },
  headerSubtitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    marginBottom: 4,
  },
  headerButtonContainer: {
    paddingRight: 16,
  },
}));
